import admin from './admin';

const menuItems = {
    items: [admin]
};

export default menuItems;
